import React from 'react';
import Hero from '../../components/landing/Hero';
import MissionVision from '../../components/landing/MissionVision';
import InitiativeShowcase from '../../components/landing/InitiativeShowcase';
import DevelopmentPhases from '../../components/landing/DevelopmentPhases';
import Programs from '../../components/landing/Programs';
import Impact from '../../components/landing/Impact';
import BoardMembers from '../../components/landing/BoardMembers';
import Partners from '../../components/landing/Partners';
import GetInvolved from '../../components/landing/GetInvolved';
import MedicalMissionPopup from '../../components/landing/MedicalMissionPopup';

export default function Home() {
  return (
    <main className="min-h-screen bg-background">
      <MedicalMissionPopup />
      <Hero />
      <MissionVision />
      <InitiativeShowcase />
      <DevelopmentPhases />
      <Programs />
      <Impact />
      <BoardMembers />
      <Partners />
      <GetInvolved />
    </main>
  );
}
